import { fetch } from '../fetchWrapper/fetch';
import { EXTENSIONS_API_URL } from '../../constants';
import { IUpdateExtensionRequest, IExtension } from './types';

export const updateExtension = async (
  brandId: string,
  extensionId: string,
  payload: IUpdateExtensionRequest,
): Promise<IExtension> => {
  try {
    const res = await fetch(`${EXTENSIONS_API_URL}/${extensionId}`, {
      method: 'PUT',
      headers: {
        'content-type': 'application/json',
        'brand-id': brandId,
      },
      body: JSON.stringify(payload),
    });
    if (res.status !== 200) {
      const errorBody = await res.json().catch(() => ({}));
      throw new Error(errorBody.message || `Request failed with status ${res.status}`);
    }
    const json: { data: IExtension } = await res.json();
    return json.data;
  } catch (e) {
    if (e instanceof Error) throw e;
    throw new Error('Could not update extension');
  }
};
